export type SpeechLanguage = "en" | "fr";

/** Language → BCP-47 locale code, used by both STT backends. */
export const VOICE_CONFIG: Record<SpeechLanguage, { locale: string }> = {
  fr: { locale: "fr-FR" },
  en: { locale: "en-US" },
};

export interface SpeechRecognitionOptions {
  language: SpeechLanguage;
  onInterimResult?: (text: string) => void;
  onFinalResult?: (text: string) => void;
  onError?: (error: Error) => void;
  onStart?: () => void;
  onEnd?: () => void;
  onTimeout?: () => void;
  silenceTimeout?: number;
}
